import React, { useState } from 'react'
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import getEnvConfig from '../../../../config'
import { fetchToken } from '../../../../Auth';

function OwnershipTransfer() {
  const { backendUrl } = getEnvConfig()
  const navigate = useNavigate()

  const [chargerId, setChargerId] = useState('')
  const [currentOwnerEmail, setCurrentOwnerEmail] = useState('')
  const [newOwnerEmail, setNewOwnerEmail] = useState('')
  const [userToken, setUserToken] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [alert, setAlert] = useState({ type: '', message: '' })
  const token = fetchToken();
  const handleSubmit = async (e) => {
    e.preventDefault()
    setAlert({ type: '', message: '' })
    setIsSubmitting(true)
    try {
      const res = await fetch(`${backendUrl}/chargers/transfer-ownership`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          charger_id: Number(chargerId),
          current_owner_email: currentOwnerEmail,
          new_owner_email: newOwnerEmail,
          user_token: token
        })
      })
      const data = await res.json()
      if (data.response === 'success') {
        setAlert({ type: 'success', message: 'Ownership transferred successfully.' })
        setChargerId('')
        setCurrentOwnerEmail('')
        setNewOwnerEmail('')
      } else {
        setAlert({ type: 'danger', message: data.message || 'Transfer failed.' })
      }
    } catch (err) {
      setAlert({ type: 'danger', message: 'Network or server error.' })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={5}>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title className="mb-4 text-center">Transfer Charger Ownership</Card.Title>
              {alert.message && (
                <Alert variant={alert.type}>{alert.message}</Alert>
              )}
              <Form onSubmit={handleSubmit} autoComplete="off">
                <Form.Group className="mb-3" controlId="chargerId">
                  <Form.Label>Charger ID</Form.Label>
                  <Form.Control
                    type="number"
                    value={chargerId}
                    onChange={e => setChargerId(e.target.value)}
                    required
                    min={1}
                    placeholder="Enter Charger ID"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="currentOwnerEmail">
                  <Form.Label>Current Owner Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={currentOwnerEmail}
                    onChange={e => setCurrentOwnerEmail(e.target.value)}
                    required
                    placeholder="Current owner's email"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="newOwnerEmail">
                  <Form.Label>New Owner Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={newOwnerEmail}
                    onChange={e => setNewOwnerEmail(e.target.value)}
                    required
                    placeholder="New owner's email"
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Transferring...' : 'Transfer Ownership'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default OwnershipTransfer 